import { TFunction } from "core/i18n";
import { ChangesWithFormComponentDefinition, ContractChangeType } from "types";

import {
    ContractNameForm,
    ElectronicCommunicationForm,
    FullPagePolicyHolderForm,
    InsurancePaymentsForm,
    VehicleCancellationForm,
    VehicleDataChangeForm,
    VehicleSubjectChangeForm,
} from "./form";

export const changesDefinition = (t: TFunction): ChangesWithFormComponentDefinition => {
    const authenticatedChangeOptions = [
        {
            code: ContractChangeType.VEHICLE_DATA_CHANGE,
            value: t("vehicle.change.type.VEHICLE_DATA_CHANGE"),
            formComponent: VehicleDataChangeForm,
        },
        {
            code: ContractChangeType.VEHICLE_SUBJECT_CHANGE,
            value: t("vehicle.change.type.VEHICLE_SUBJECT_CHANGE"),
            formComponent: VehicleSubjectChangeForm,
        },
        {
            code: ContractChangeType.CONTRACT_CANCELLATION,
            value: t("changeType.contractCancellation"),
            formComponent: VehicleCancellationForm,
        },
        {
            code: ContractChangeType.INSURANCE_PAYMENTS,
            value: t("changeType.INSURANCE_PAYMENTS"),
            formComponent: InsurancePaymentsForm,
        },
        {
            code: ContractChangeType.CONTRACT_NAME,
            value: t("changeType.CONTRACT_NAME"),
            formComponent: ContractNameForm,
        },
        {
            code: ContractChangeType.POLICY_HOLDER,
            value: t("changeType.POLICY_HOLDER"),
            formComponent: FullPagePolicyHolderForm,
        },
        {
            code: ContractChangeType.ELECTRONIC_COMMUNICATION,
            value: t("changeType.ELECTRONIC_COMMUNICATION"),
            formComponent: ElectronicCommunicationForm,
        },
    ];

    const oneTimeChangeOptions = [
        {
            code: ContractChangeType.VEHICLE_DATA_CHANGE,
            value: t("vehicle.change.type.VEHICLE_DATA_CHANGE"),
            formComponent: VehicleDataChangeForm,
        },
        {
            code: ContractChangeType.VEHICLE_SUBJECT_CHANGE,
            value: t("vehicle.change.type.VEHICLE_SUBJECT_CHANGE"),
            formComponent: VehicleSubjectChangeForm,
        },
        {
            code: ContractChangeType.CONTRACT_CANCELLATION,
            value: t("changeType.contractCancellation"),
            formComponent: VehicleCancellationForm,
        },
    ];

    return {
        authenticatedChangeOptions,
        oneTimeChangeOptions,
    };
};
